export const DEPARTURE_REPORT_ENDPOINT = `report/departure`;
